import { makeColumns } from "@local/lamina-core";

function formatColumns(g, t, oc, jc, sc) {
  const cols = makeColumns(g, t, true, oc, jc, sc);
  return cols.map((col) => {
    if (col.type === "multi-column") {
      const { subcolumns, ...c } = col;

      return {
        ...c,
        ...subcolumns[c.result],
        label: c.label || subcolumns[c.result].label,
      };
    }

    return col;
  });
}

export { formatColumns };
